import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUniversity, FaLaptopCode, FaUserGraduate, FaSchool } from 'react-icons/fa';
import '../styles/Projects.scss';

function Projects() {
  const navigate = useNavigate();

  const categoryCards = [
    {
      title: 'MBA',
      subtitle: 'Business-focused premium projects',
      icon: <FaUniversity />,
      action: () => navigate('/mba-projects'),
      highlight: true,
    },
    {
      title: 'Software Project',
      subtitle: 'BE/BTech, BCA/MCA, Diploma & Tech projects',
      icon: <FaLaptopCode />,
      action: () => navigate('/program-projects?program=Software-Project'),
    },
  ];

  return (
    <div className="projects-page">
      <div className="projects-body">
        <section className="projects-categories">
          <div className="categories-header">
            <h2>Browse by Program</h2>
            <p>Select your category to explore curated project packs.</p>
          </div>
          <div className="category-grid">
            {categoryCards.map(card => (
              <button
                key={card.title}
                type="button"
                className={`category-card ${card.highlight ? 'highlight' : ''}`}
                onClick={card.action}
              >
                <div className="card-glow" />
                <div className="card-icon">{card.icon}</div>
                <div className="card-content">
                  <h3>{card.title}</h3>
                  <span>{card.subtitle}</span>
                </div>
                <div className="card-cta">Explore →</div>
              </button>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default Projects;
